import React, { useEffect, useRef } from "react";
import { useLanderConfig } from "../commons/ConfigContext";
import { ErrorCode, EventType, QueryParam } from "../commons/Constants";
import postEvent, { createBaseLanderEvent } from "../commons/LanderEvent";
import { Settings } from "../config";

const errorPageStyle = `body {
  margin: auto;
  padding: 10px;
  background-color: #F3F7FC;
  font-family: 'Arial';
}`;

export function InactiveLander() {
  const { landerConfig, queryConfig } = useLanderConfig();
  const eventFiredRef = useRef(false);

  useEffect(() => {
    if (eventFiredRef.current) return;
    eventFiredRef.current = true;

    const event = createBaseLanderEvent(EventType.ERROR, landerConfig);
    event.errorCode = ErrorCode.ERROR_DOMAIN_STATUS_INVALID;
    event.sToken = queryConfig[QueryParam.S_TOKEN];
    postEvent(Settings.EVENT_PUBLISH_API, event);
  }, [landerConfig, queryConfig]);

  return (
    <>
      <style>{errorPageStyle}</style>
      <div id="errorMessage" />
    </>
  );
}
